import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApiService } from '../../services/api.service';
import { ProjectType } from '../../models/api.models';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';

@Component({
  selector: 'app-role-list',
  standalone: true,
  imports: [CommonModule, TableModule, ButtonModule, ToastModule],
  providers: [MessageService],
  templateUrl: './role-list.component.html',
  styleUrl: './role-list.component.scss'
})
export class RoleListComponent implements OnInit {
  roles: any[] = [];
  loading: boolean = false;
  selectedClient: ProjectType = ProjectType.SVN;
  projectTypes = [
    { label: 'SVN', value: ProjectType.SVN },
    { label: 'SOVRN', value: ProjectType.SOVRN },
    { label: 'CAPITAL', value: ProjectType.CAPITAL }
  ];

  constructor(
    private apiService: ApiService,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.loadRoles();
  }

  loadRoles(): void {
    this.loading = true;
    this.apiService.getRolesByClient(this.selectedClient).subscribe({
      next: (response) => {
        this.roles = response && response.data ? response.data : [];
        this.loading = false;
      },
      error: (err) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to load roles'
        });
        this.loading = false;
      }
    });
  }

  switchClient(client: ProjectType): void {
    this.selectedClient = client;
    this.loadRoles();
  }
}
